import React from 'react';

export const Faq: React.FC = () => {
  return (
    <div className="bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 lg:py-14">
          <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-2">
            FAQ · Nettoyage logement insalubre 06 / 83
          </p>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
            FAQ N.L.I Nice · Nettoyage logement insalubre, Diogène et nettoyage extrême
          </h1>
          <p className="text-sm text-slate-600 max-w-3xl">
            Vous trouverez ici les réponses aux questions les plus fréquentes sur
            le <strong>nettoyage de logements insalubres</strong>, les{' '}
            <strong>cas de syndrome de Diogène</strong> et le{' '}
            <strong>nettoyage extrême</strong> pris en charge par{' '}
            <strong>N.L.I Nice</strong> dans les Alpes-Maritimes (06) et le Var (83).
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-10 lg:py-14">
        <div className="grid gap-6 lg:grid-cols-2">
          <div className="space-y-4">
            <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs sm:text-sm text-slate-700">
              <h2 className="text-sm sm:text-base font-semibold text-slate-900 mb-2">
                Qui est N.L.I Nice et dans quoi êtes-vous spécialisés ?
              </h2>
              <p>
                <strong>N.L.I Nice</strong> est une entreprise spécialisée dans le{' '}
                <strong>nettoyage de logements insalubres</strong>, le{' '}
                <strong>syndrome de Diogène</strong>, le <strong>nettoyage extrême</strong>{' '}
                et le débarras massif. Nous intervenons pour les particuliers, familles,
                notaires, agences immobilières et syndics qui doivent remettre en état
                un appartement ou une maison très sale dans le 06 et le 83.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs sm:text-sm text-slate-700">
              <h2 className="text-sm sm:text-base font-semibold text-slate-900 mb-2">
                Dans quelles situations faire appel à N.L.I Nice ?
              </h2>
              <p>
                Vous pouvez faire appel à nous dès qu&apos;un logement est{' '}
                <strong>trop sale ou encombré pour un ménage classique</strong> :
                accumulation de déchets, syndrome de Diogène, odeurs fortes,
                nuisibles, logement abandonné, squat, succession, départ de locataire
                laissant un appartement insalubre, etc. N.L.I Nice prend en charge le
                débarras, le nettoyage en profondeur, la désinfection et la
                désodorisation.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs sm:text-sm text-slate-700">
              <h2 className="text-sm sm:text-base font-semibold text-slate-900 mb-2">
                Quels sont vos secteurs d&apos;intervention ?
              </h2>
              <p>
                N.L.I Nice intervient sur l&apos;ensemble de la{' '}
                <strong>Côte d&apos;Azur</strong> dans les Alpes-Maritimes (06) et le
                Var (83) : Nice, Cannes, Antibes, Menton, Grasse, Cagnes-sur-Mer,
                Vence, Toulon, La Seyne-sur-Mer, Hyères, Fréjus, Saint-Raphaël,
                Draguignan et les communes voisines.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs sm:text-sm text-slate-700">
              <h2 className="text-sm sm:text-base font-semibold text-slate-900 mb-2">
                Comment se déroule un nettoyage logement insalubre ?
              </h2>
              <p>
                Une intervention de <strong>nettoyage logement insalubre</strong> avec
                N.L.I Nice suit généralement quatre grandes étapes :{' '}
                <strong>diagnostic</strong> (photos, visite, devis),{' '}
                <strong>débarras</strong> des déchets et encombrants,{' '}
                <strong>nettoyage extrême</strong> (cuisine, salle de bain, sols,
                surfaces) et <strong>désinfection / désodorisation</strong>. L&apos;objectif
                est de rendre le bien à nouveau habitable ou présentable pour la vente
                ou la location.
              </p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs sm:text-sm text-slate-700">
              <h2 className="text-sm sm:text-base font-semibold text-slate-900 mb-2">
                Combien coûte un nettoyage logement insalubre ?
              </h2>
              <p>
                Le <strong>prix d&apos;un nettoyage logement insalubre</strong> dépend
                de la surface, du volume de déchets, du niveau d&apos;insalubrité et de
                l&apos;accessibilité. À titre indicatif, un petit logement très encombré
                peut démarrer autour de 800 € TTC, un appartement T2/T3 insalubre entre
                1 500 et 3 000 € TTC, et une grande maison très dégradée à partir de
                3 000 € TTC. N.L.I Nice fournit toujours un devis personnalisé sur
                photos ou après visite.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs sm:text-sm text-slate-700">
              <h2 className="text-sm sm:text-base font-semibold text-slate-900 mb-2">
                Comment obtenir un devis rapide (WhatsApp, photos) ?
              </h2>
              <p>
                Pour un <strong>devis nettoyage logement insalubre</strong> rapide, le
                plus simple est d&apos;envoyer un message WhatsApp à{' '}
                <strong>+33 7 45 17 13 31</strong> avec : la ville, la surface
                approximative, le type de logement (studio, appartement, maison) et
                quelques photos des pièces principales. N.L.I Nice vous répond avec une
                estimation réaliste et une proposition de date d&apos;intervention.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs sm:text-sm text-slate-700">
              <h2 className="text-sm sm:text-base font-semibold text-slate-900 mb-2">
                Travaillez-vous avec des notaires, agences immobilières et syndics ?
              </h2>
              <p>
                Oui, <strong>N.L.I Nice</strong> travaille régulièrement avec des{' '}
                <strong>notaires, agences immobilières, syndics de copropriété et bailleurs sociaux</strong>{' '}
                pour la remise en état de logements insalubres, appartements très
                sales ou maisons Diogène. Nous fournissons des devis détaillés, des
                photos avant/après et des factures exploitables dans les dossiers de
                succession, de vente ou de relocation.
              </p>
            </div>

            <div className="rounded-2xl border border-slate-200 bg-white p-4 text-xs sm:text-sm text-slate-700">
              <h2 className="text-sm sm:text-base font-semibold text-slate-900 mb-2">
                La discrétion et la confidentialité sont-elles garanties ?
              </h2>
              <p>
                La <strong>discrétion</strong> et la <strong>confidentialité</strong>
                font partie de nos priorités. Les interventions N.L.I Nice sont
                organisées de façon à limiter le regard du voisinage, les équipes
                travaillent avec respect et nous ne partageons jamais de photos sans
                accord écrit. C&apos;est particulièrement important pour les familles
                confrontées à un cas de syndrome de Diogène ou à un logement
                fortement dégradé.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

